<template>
  <slice
    :id="block._key"
    class="slice slice--background-content"
    :class="getClass()"
  >
    <div class="img">
      <lazy-image :image="image" provider="sanity" class="d-none d-md-block" />
      <lazy-image
        :image="imageMobile"
        provider="sanity"
        :widths="[320, 414, 640, 769]"
        class="d-md-none"
      />
    </div>
    <div class="container">
      <div class="row-md" :class="blockPosition">
        <div class="col-md-1"></div>
        <div class="col-md-3 text">
          <portable-text v-if="hasText" :blocks="block.text" />
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'
import LazyImage from '@/components/Image/LazyImage'
import { getSanityBunnyImageLink } from '@/utils/image'

export default {
  name: 'BlockBackgroundContent',
  components: {
    Slice,
    PortableText,
    LazyImage,
  },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    image() {
      return {
        url: getSanityBunnyImageLink(this.block.image, {
          width: 1140,
          height: 960,
        }),
        dimensions: {
          width: 1400,
          height: 960,
        },
      }
    },
    imageMobile() {
      return {
        url: getSanityBunnyImageLink(this.block.image, {
          width: 440,
          height: 280,
        }),
        dimensions: {
          width: 440,
          height: 280,
        },
      }
    },
    hasText() {
      return this.block.text && this.block.text.length > 0
    },
    blockPosition() {
      switch (this.block.block_position) {
        case 'center':
          return 'justify-center'
        case 'right':
          return 'justify-end'
        case 'left':
        default:
          return 'justify-start'
      }
    },
  },
  methods: {
    getClass() {
      const cc = []

      if (this.block.is_full) {
        cc.push('slice--full-height')
      }

      return cc
    },
  },
}
</script>

<style lang="scss">
.slice--background-content {
  margin-left: auto;
  margin-right: auto;
  transition: max-width 0.6s;

  @include mq($from: tablet) {
    position: relative;
    padding: rem($spacing * 8) 0;
    overflow: hidden;

    .img {
      position: absolute;
      inset: 0;
    }

    .lazy-image-container {
      height: 100%;
    }

    .lazy-image {
      padding-top: 0 !important;
      height: 100%;

      img {
        max-width: none;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
      }
    }
  }

  @include mq($until: tablet) {
    .container {
      transition: padding 0.6s;
    }
  }

  .text {
    padding: rem($spacing * 2) 0;
    background: var(--tertiary-color);
    z-index: 1;

    @include mq($from: tablet) {
      flex: 0 0 rem(433px);
      padding: rem($spacing * 4);
    }
  }

  .lazy-image-container {
    background: transparent;
  }

  .lazy-image {
    img {
      left: 50%;
      transform: translateX(-50%);
      transition: transform 0.6s;
    }

    &.loaded {
      background: transparent !important;
    }
  }
}

.slice--full-height {
  min-height: 100vh;
}
</style>
